import { render, staticRenderFns } from "./ReturnReason.vue?vue&type=template&id=097c5d40&scoped=true&"
import script from "./ReturnReason.vue?vue&type=script&lang=js&"
export * from "./ReturnReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097c5d40",
  null
  
)

export default component.exports